import { Home } from 'lucide-react';
import { Link } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/ui/base/breadcrumb';

import { truncarRotulo } from './apresentacao';
import { type ItemDeNavegacao } from './mapa';

/**
 * Faixa de breadcrumb da casca: ícone de casa pra raiz da área, o nome do
 * item de menu, e — quando a tela define (`useMigalhaExtra`,
 * `MigalhaExtra.tsx`) — um terceiro segmento pra dentro dele (a aba ativa de
 * um hub, o registro aberto numa tela de detalhe). Deriva de
 * `itemPorPrefixoDeCaminho` (nucleo/navegacao/mapa.ts), a mesma fonte que
 * alimenta a barra lateral, sem lista paralela.
 *
 * O ícone de casa vai pra raiz da ÁREA (ex.: /operacao), não pra "/": aqui "/"
 * é o portal público, fora da casca logada.
 *
 * Com `extra` presente, o segmento do meio (`item.titulo`) vira link — ele
 * deixa de ser "a página atual" pra ser um passo intermediário do caminho.
 */
export function Migalhas({
  raizDaArea,
  grupo,
  item,
  extra,
}: {
  raizDaArea: string;
  /**
   * Grupo de menu da rota (`grupoDoItem`, mapa.ts). Entra como segmento do
   * meio, sem link: grupo é rótulo de seção da barra lateral, não rota.
   */
  grupo?: string | null;
  item: ItemDeNavegacao | undefined;
  extra?: string | null;
}) {
  return (
    <div className="flex h-10 shrink-0 items-center border-t border-border/40 px-3 sm:px-4">
      <Breadcrumb>
        <BreadcrumbList className="flex-nowrap">
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link
                to={raizDaArea}
                className="flex items-center"
                aria-label="Página inicial da área"
              >
                <Home className="h-3.5 w-3.5" aria-hidden="true" />
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>

          {grupo && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem className="hidden max-w-[180px] truncate sm:inline-flex">
                <span className="text-muted-foreground">{truncarRotulo(grupo)}</span>
              </BreadcrumbItem>
            </>
          )}

          {item && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {extra ? (
                  <BreadcrumbLink asChild>
                    <Link to={item.caminho} className="max-w-[160px] truncate sm:max-w-none">
                      {truncarRotulo(item.titulo)}
                    </Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage className="max-w-[220px] truncate sm:max-w-none">
                    {truncarRotulo(item.titulo)}
                  </BreadcrumbPage>
                )}
              </BreadcrumbItem>
            </>
          )}

          {extra && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="max-w-[140px] truncate sm:max-w-[360px]" title={extra}>
                  {truncarRotulo(extra, 60)}
                </BreadcrumbPage>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}
